<template>
  <client-form />
</template>

<script>
import ClientForm from './Form'

export default {
  name: 'Edit',
  components: { ClientForm },
  metaInfo () {
    return {
      title: this.$t('string.editBorrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
